import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SupportContactService } from '../../../services/support-contact.service';

@Component({
  selector: 'app-sign-in-failed',
  imports: [],
  templateUrl: './sign-in-failed.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './sign-in-failed.component.scss',
})
export class SignInFailedComponent implements OnInit {
  public mailLink = '';

  private supportContactService = inject(SupportContactService);

  public ngOnInit(): void {
    this.mailLink = this.supportContactService.getSupportMailLink("\nThe user couldn't sign in.");
  }
}
